export enum SCHEDULE_TYPE_ENUM {
  PAYMENT_PRIMARY = 'PAYMENT_PRIMARY',
  OBS_PRIMARY = 'OBS_PRIMARY',
  INDEPENDENT = 'INDEPENDENT',
  PAYMENT_ONLY = 'PAYMENT_ONLY',
  OBS_ONLY = 'OBS_ONLY',
  ACCRUAL_PRIMARY = 'ACCRUAL_PRIMARY',
  ADJUSTMENT = 'ADJUSTMENT',
  INVESTOR_EXERCISE = 'INVESTOR_EXERCISE',
}
